import React from 'react';
import TextField from '@mui/material/TextField';

/**
 * Select field backed by a native <select>.
 *
 * Native on purpose: callers pass <option> children and read `event.target.value`, which is what
 * both redux-form and react-final-form wire up. Swapping in MUI's MenuItem list would change that
 * contract. `type` is swallowed because callers pass type='select', not a valid input type.
 */
const NativeSelectField = ({ children, type: _type = undefined, ...rest }) => (
  <TextField select slotProps={{ select: { native: true } }} {...rest}>
    {children}
  </TextField>
);

export default NativeSelectField;
